import { FormBase } from 'core/components';

export default class FacilityAdditionalContactForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.NAME',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.NAME_PLACEHOLDER',
                    type:'string',
                },
                 {
                    name: 'lastName',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.LAST_NAME',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.LAST_NAME_PLACEHOLDER',
                    type:'string',
                },
                {
                    name: 'title',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.TITLE',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.TITLE_PLACEHOLDER',
                    type:'string'
                },
                {
                    name: 'department',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.DEPARTMENT',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.DEPARTMENT_PLACEHOLDER',
                },
                {
                    name: 'facilityAdditionalContactContactDepartments',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.DEPARTMENT',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.DEPARTMENT_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'extension',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.EXTENSION',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.EXTENSION_PLACEHOLDER',
                    type:'string'
                },
                {
                    name: 'phone',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.PHONE',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.PHONE_PLACEHOLDER',
                    type:'string'
                },
                {
                    name: 'email',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.EMAIL',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.EMAIL_PLACEHOLDER',
                    rules:'email|string'
                },
                {
                    name: 'isPrimary',
                    type:'bool',
                    value:false
                },
                {
                    name: 'inActive',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.IN_ACTIVE',
                    type:'bool',
                    value:false
                },
                {
                    name: 'note',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.NOTE',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.NOTE_PLACEHOLDER',
                    type:'string'
                },
                {
                    name: 'facilityId',
                    type:'string'
                },
                { 
                    name: "overviewRecipientType", 
                    type: "text" 
                },
                { 
                    name: "docRequestRecipientType", 
                    type: "text" 
                },
                { 
                    name: "inventoryRecipientType", 
                    type: "text"
                },
                {
                    name: "pickTicketRecipientType", 
                    type: "text" 
                },
                 {
                    name: "deliveryTicketType", 
                    type: "text" 
                }
            ],
        };
    }
}
